export const USER_ACTION = {
  USER: 'USER',
  USER_CITY: 'USER_CITY',
  USER_SETTINGS: 'USER_SETTINGS',
  UPDATE_USER_FIELDS: 'UPDATE_USER_FIELDS',
  UPDATE_USER_SETTINGS: 'UPDATE_USER_SETTINGS',
  UPDATE_MAIN_USER_INFO: 'UPDATE_MAIN_USER_INFO',
  UPDATE_PUSH_TOKEN: 'UPDATE_USER_PUSH_TOKEN'
};